import { MediaService } from './../../../../services/shared/media.service';
import { MAX_ARCHIVO_MB } from '@components/ofertas-laborales/common/helpers/archivos.helper';
import { Component, Inject, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Solicitud } from '../../../../interfaces/interface-bakend/ofertas-laborales/solicitudes.interface';
import { GuiMsjService } from '../../../../services/shared/gui-msj.service';
import { SolicitudesService } from '../../../../services/ofertas-laborales/solicitudes.service';
import { Translators } from '../../../../services/shared/translators.service';
import { StepperActualizacionService } from '@services/shared/stepper-actualizacion.service';

export interface DialogData {
    solicitud: Solicitud;
    adjunto: string;
    label: string;
    numberState: number;
    labelButton: string;
    accept: string; // image/jpeg, image/jpg, image/png, application/pdf
}

@Component({
    selector: 'app-upload-file-solicitud',
    templateUrl: './upload-file-solicitud.component.html',
    styleUrls: ['./upload-file-solicitud.component.scss'],
})
export class UploadFileSolicitudComponent implements OnInit {
    activarCargaDocumento = false;
    value = 0;
    subscriptionAvance: Subscription;
    flagLoading = false;
    selectedFile: any;
    solicitud: Solicitud;
    flagDisableButton = false;

    idioma: Subscription;

    constructor(
        private mediaService: MediaService,
        private guiMsjService: GuiMsjService,
        private solicitudesService: SolicitudesService,
        private translatorService: Translators,
        private stepperActualizacionService: StepperActualizacionService,
        /* Modal Ref. */
        public dialogRef: MatDialogRef<UploadFileSolicitudComponent>,
        @Inject(MAT_DIALOG_DATA) public data: DialogData /* Fin Modal Ref. */
    ) {
        this.idioma = this.translatorService
            .getIdiomaSeleccionado()
            .subscribe((resp) => {
                this.idioma = resp;
            });

        this.subscribeAvanceUpload();
    }

    ngOnInit(): void {}

    async onFileSelected(event) {
        const rawFile = event.target.files[0];

        if (!this.mediaService.controlSize(event)) {
            alert(`Archivo demasiado grande. Máximo permitido: ${MAX_ARCHIVO_MB} MB.`);
            this.flagDisableButton = true;
            return;
        }

        this.selectedFile = rawFile;
        this.flagDisableButton = false; // habilita botón ACEPTAR
        this.flagLoading = false;
    }

    subscribeAvanceUpload() {
        this.subscriptionAvance = this.mediaService
            .getAvance()
            .subscribe((resp) => {
                if (resp) {
                    this.value = resp.value;
                } else {
                    this.value = 0;
                }
            });
    }

    async aceptar(): Promise<void> {
        if (!this.selectedFile) {
            alert('No seleccionaste ningún archivo.');
            return;
        }

        this.dialogRef.close({
            file: this.selectedFile,
            fileName: this.selectedFile.name,
        });
    }

    async closeModal(): Promise<void> {
        this.dialogRef.close(false);
    }

    async actualizarEstadoSolicitud(_id: string, numberState: number) {
        return new Promise((resolve) => {
            this.solicitudesService
                .updateSolicitudState(_id, numberState, false)
                .then(async (solicitudUpdated: Solicitud) => {
                    if (solicitudUpdated) {
                        this.solicitudesService.setSolicitudSeleccionada(
                            solicitudUpdated
                        );
                        this.dialogRef.close(true);
                        this.guiMsjService.msjFormSubmit('uploadDocumentOK');

                        //Actualizacion del stepper cuando actualizo el estado de la solicitud
                        this.stepperActualizacionService.actualizarEstado(
                            numberState
                        );
                    } else {
                        this.guiMsjService.msjFormSubmit('uploadDocumentError');
                    }
                });
        });
    }
}
